import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ICheckoutTotalOptions } from '../../components/checkout-total/checkout-total.component';
import { IStore } from '../../services/store.service';
import { IOrderItem, OrderService } from '../../services/order.service';
import { IPlacePreOrderBase } from '../../services/preorder.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-table-order-details-modal',
    templateUrl: './table-order-details-modal.component.html',
    styleUrls: ['./table-order-details-modal.component.scss'],
    standalone: false
})
export class TableOrderDetailsModalComponent implements OnInit, AfterViewInit {
  orderTableItems: IOrderItem[];

  @Input() order: IPlacePreOrderBase;
  @Input() store: IStore;

  @ViewChild('content', {read: ElementRef, static:false}) content: ElementRef;
  @ViewChild('tableToolBar', {read: ElementRef, static:false}) tableToolBar: ElementRef;
  @ViewChild('tableContent', {read: ElementRef, static:false}) tableContent: ElementRef;
  @ViewChild('tableGrid', {read: ElementRef, static:false}) tableGrid: ElementRef;
  @ViewChild('tableDiv', {read: ElementRef, static:false}) tableDiv: ElementRef;

  get subTotal(): number {
    let subTotal = 0;
    this.order.preOrder.preOrderItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });
      }
    });
    return subTotal;
  }

  get totalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: false,
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.subTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }

  constructor(
    private modalCtrl: ModalController,
    //public translateService: TranslateService,
    public orderService: OrderService,
    public translationService: TranslationService
    ) { }

  ngOnInit() { 
    this.orderTableItems = this.order.preOrder.preOrderItems.filter(item => item.orderType == "table");

    //we need to filter out the items with quantity 0 from the UI, it generates empty row and breaks the cart UI
    this.filterOutZeroQuantity(this.orderTableItems);
  }

  ngAfterViewInit(): void {
    this.setContentHeight();
  }

  getOptionName(name: any)
  { 
      if(name.translations)
      {
          return name.translations[this.translationService.getLanguage()];
      }
        return name; 
  }
  getItemName(item: any)
  { 
    if(item){
      if(item.itemName.translations)
      {
          return item.itemName.translations[this.translationService.getLanguage()]
      }
      else
      {
        return item.itemName
      }
    }
  }
  
  close()
  {
    this.modalCtrl.dismiss();
  }


  filterOutZeroQuantity(orderItems: IOrderItem[]) { 
    for (let i = 0; i < orderItems.length; i++) {
      for (let j = orderItems[i].options.length - 1; j > 0; j--) {
        if (orderItems[i].options[j].quantity == 0) {
            orderItems[i].options.splice(j, 1);
        }
      }     
    }
  }

  private setContentHeight(){
    setTimeout(() => {
      let totalHeight: number = 0;
      let contents: any[] = [];
      if(this.tableContent){
        this.tableContent.nativeElement.style.height = 
          this.content.nativeElement.offsetHeight - this.tableToolBar.nativeElement.offsetHeight + 'px';
        this.tableGrid.nativeElement.style.height = 
          this.tableContent.nativeElement.offsetHeight - this.tableDiv.nativeElement.offsetHeight + 'px';
        return;
      }
      if(this.content.nativeElement.offsetHeight > totalHeight){
        let addSpaceAmount = (this.content.nativeElement.offsetHeight - totalHeight)/contents.length;
        for(let content of contents){
          content.nativeElement.style.height = content.nativeElement.offsetHeight + addSpaceAmount + 'px';
        }
      }
    }, 1);
  }
}